import React from "react";

import glamorous from "glamorous";
import { Hero, HeroTitle } from "../components/Hero";
import { Funnel, FunnelTitle } from "../components/Funnel";
import FeatureButton from "../components/FeatureButton";
import * as Icons from "../components/FeatureIcons";

import PlansBackground from "../assets/plans-bg.png";

const Section = glamorous.div(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "4.5rem 1.0875rem",
  ":nth-child(even):not(.funnel,.integration)": {
    background: theme.main.colors.light
  }
}));

const PlanDescription = glamorous.div(({ theme }) => ({
  margin: "auto 3rem auto 0",
  width: "40%",
  [theme.main.mediaQueries.mobile]: {
    textAlign: "center",
    width: "90%"
  }
}));

const PlanFeatures = glamorous.div(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  width: "60%",
  [theme.main.mediaQueries.mobile]: {
    width: "100%"
  }
}));

const Feature = glamorous.div({
  alignItems: "center",
  display: "flex",
  padding: "1rem 0",
  fontWeight:  800,
  width: "45%",
  "& div": {
    textAlign: "center",
    width: "80%"
  }
});

const EmailLink = glamorous.a({
  color: "#fff",
  display: "block",
  textDecoration: "none",
  textUnderlinePosition: "under",
  marginLeft: "3rem",
  ":hover": {
    textDecoration: "underline"
  }
});

const NarrowContainer = glamorous.div(({ theme }) => ({
  display: "flex",
  maxWidth: (theme.main.maxWidths.default * 0.75),
  [theme.main.mediaQueries.mobile]: {
    flexDirection: "column"
  }
}));

const PlansPage = ({ onToggleContactForm }) => (
  <div>
    <Hero glam={{ background: `#1e485f url('${PlansBackground}') repeat center` }}>
      <HeroTitle color="#fff">A plan fit for you</HeroTitle>
      <NarrowContainer>
        <glamorous.P fontSize="24px" color="#fff" textAlign="center">Manta Equipment is just getting started, and we are dedicated to building a platform that suits you. Get a solution tailored to your needs.
        </glamorous.P>
      </NarrowContainer>
      <FeatureButton onClick={onToggleContactForm}>Arrange a Demo</FeatureButton>
    </Hero>
    <Section>
      <NarrowContainer>
        <PlanDescription>
          <h2>The custom plan</h2>
          <p>Instead of having to fit into predefined plans, just let us know what features you need and we&apos;ll make it happen.</p>
          <strong>Live support, unlimited users, premium service.</strong>
        </PlanDescription>
        <PlanFeatures>
          <Feature><Icons.OnDemandSupport /><div>On-demand support</div></Feature>
          <Feature><Icons.ImportExport /><div>Import and export</div></Feature>
          <Feature><Icons.CustomAdditions /><div>Custom additions</div></Feature>
          <Feature><Icons.UnlimitedDepartments /><div>Unlimited departments</div></Feature>
          <Feature><Icons.BatteriesIncluded /><div>Batteries included</div></Feature>
          <Feature><Icons.FullControl /><div>Full control</div></Feature>
        </PlanFeatures>
      </NarrowContainer>
    </Section>
    <Funnel css={{ flexDirection: "column" }}>
      <FunnelTitle css={{ marginBottom: "1rem" }}>Get in touch</FunnelTitle>
      <glamorous.Div display="flex" justifyContent="space-between" alignItems="center">
        <FeatureButton href="https://m.me/MantaEquipment?ref=plans">
          <Icons.Messenger />
          <span>Talk to us on Messenger</span>
        </FeatureButton>
        <EmailLink href="#" onClick={onToggleContactForm}>Send us an email</EmailLink>
      </glamorous.Div>
    </Funnel>
  </div>
);

export default PlansPage;



// WEBPACK FOOTER //
// ./src/pages/plans.js